export default [
    '$rootScope',
    '$translate',
    'BatteryStatusService',
    function ($rootScope, $translate, batteryStatusService) {
        return {
            restrict: 'E',
            scope: {},
            bindToController: {},
            controllerAs: 'ctrl',
            controller: [function () {
                    this.available = () => batteryStatusService.dataAvailable;
                    this.alert = () => batteryStatusService.isLow && !batteryStatusService.isCharging;
                    this.percent = () => batteryStatusService.percent;
                    this.description = () => {
                        if (batteryStatusService.isCharging) {
                            return $translate.instant('battery.CHARGING', {
                                percent: this.percent(),
                            });
                        }
                        else if (this.alert()) {
                            return $translate.instant('battery.ALERT', {
                                percent: this.percent(),
                            });
                        }
                        return $translate.instant('battery.DISCHARGING', {
                            percent: this.percent(),
                        });
                    };
                    this.icon = () => {
                        if (batteryStatusService.isCharging) {
                            return 'battery_charging_full';
                        }
                        else if (this.alert()) {
                            return 'battery_alert';
                        }
                        return 'battery_std';
                    };
                }],
            template: `
                <div class="battery-status" ng-if="ctrl.available()"" ng-class="{'alert': ctrl.alert()}">
                    <md-icon
                        aria-label="Battery status: {{ ctrl.description() }}"
                        title="{{ ctrl.description() }}"
                        class="material-icons md-light md-24">{{ ctrl.icon() }}</md-icon>
                    <span class="battery-percent" aria-hidden="true">{{ ctrl.percent() }}%</span>
                </div>
            `,
        };
    },
];
